/**
 * Converts a glob-like URL pattern into a RegExp.
 * Supports `*` (path segment without `/`), `**` (任意剩余路径含 `/`、query), `?` (单字符).
 * 例：B 站常见 `/video/BVxxx/?spm=...`，须用 `.../video/**` 而非 `.../video/*`。
 */
function globToRegExp(pattern: string): RegExp {
  let regexStr = "";
  let i = 0;

  while (i < pattern.length) {
    const char = pattern[i];

    if (char === "*") {
      if (pattern[i + 1] === "*") {
        regexStr += ".*";
        i += 2;
      } else {
        regexStr += "[^/]*";
        i++;
      }
    } else if (char === "?") {
      regexStr += ".";
      i++;
    } else if (".+^${}()|[]\\".includes(char)) {
      regexStr += "\\" + char;
      i++;
    } else {
      regexStr += char;
      i++;
    }
  }

  return new RegExp("^" + regexStr + "$", "i");
}

export interface ViewerMatch {
  pluginId: string;
  pattern: string;
}

export class UrlMatcher {
  private matchers = new Map<string, { patterns: string[]; regexps: RegExp[] }>();

  register(pluginId: string, urlPatterns: string[]): void {
    this.matchers.set(pluginId, {
      patterns: urlPatterns,
      regexps: urlPatterns.map(globToRegExp),
    });
  }

  unregister(pluginId: string): void {
    this.matchers.delete(pluginId);
  }

  match(url: string): ViewerMatch[] {
    const matches: ViewerMatch[] = [];

    for (const [pluginId, { patterns, regexps }] of this.matchers) {
      for (let i = 0; i < regexps.length; i++) {
        if (regexps[i].test(url)) {
          matches.push({ pluginId, pattern: patterns[i] });
          break;
        }
      }
    }

    return matches;
  }

  hasMatch(url: string): boolean {
    return this.match(url).length > 0;
  }
}
